import {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

import {AdminReportsSection} from "../../../sections/admin/AdminReportsSection";

class PlaygroundReports extends Component {

    componentDidMount() {
        this.props.setFullscreen(false);
    }

    render() {
        const {computedMatch} = this.props;

        if (!computedMatch || !computedMatch.params) {
            return null;
        }

        const {playgroundId} = computedMatch.params;

        return (
            <AdminReportsSection playgroundId={playgroundId}/>
        );
    }
}

PlaygroundReports.propTypes = {
    computedMatch: PropTypes.object,
    setFullscreen: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
};

export default withRouter(PlaygroundReports);

